"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const ColorSchemeFactory_1 = __importDefault(require("../ColorSchemeFactory"));
const CustomColorsContext_1 = require("../CustomColorsContext");
function ColorPaletteCollectionComponent(props) {
    const palettes = [
        { type: "schemeSet1", reversed: false },
        { type: "schemeSet2", reversed: false },
        { type: "schemeSet3", reversed: false },
        { type: "schemeAccent", reversed: false },
        { type: "schemeDark2", reversed: false },
        { type: "schemePaired", reversed: false },
        { type: "schemePastel1", reversed: false },
        { type: "schemePastel2", reversed: false },
        { type: "interpolateSpectral", reversed: false },
        { type: "interpolateSpectral", reversed: true },
        { type: "interpolateBlues", reversed: false },
        { type: "interpolateBlues", reversed: true },
        { type: "interpolateGreens", reversed: false },
        { type: "interpolateGreens", reversed: true },
        { type: "interpolateGreys", reversed: false },
        { type: "interpolateGreys", reversed: true },
        { type: "interpolateOranges", reversed: false },
        { type: "interpolateOranges", reversed: true },
        { type: "interpolatePurples", reversed: false },
        { type: "interpolatePurples", reversed: true },
        { type: "interpolateReds", reversed: false },
        { type: "interpolateReds", reversed: true },
        { type: "interpolateBuGn", reversed: false },
        { type: "interpolateBuGn", reversed: true },
        { type: "interpolateBuPu", reversed: false },
        { type: "interpolateBuPu", reversed: true },
        { type: "interpolateGnBu", reversed: false },
        { type: "interpolateGnBu", reversed: true },
        { type: "interpolateOrRd", reversed: false },
        { type: "interpolateOrRd", reversed: true },
        { type: "interpolatePuBuGn", reversed: false },
        { type: "interpolatePuBuGn", reversed: true },
        { type: "interpolatePuBu", reversed: false },
        { type: "interpolatePuBu", reversed: true },
        { type: "interpolatePuRd", reversed: false },
        { type: "interpolatePuRd", reversed: true },
        { type: "interpolateRdPu", reversed: false },
        { type: "interpolateRdPu", reversed: true },
        { type: "interpolateYlGnBu", reversed: false },
        { type: "interpolateYlGnBu", reversed: true },
        { type: "interpolateYlGn", reversed: false },
        { type: "interpolateYlGn", reversed: true },
        { type: "interpolateYlOrBr", reversed: false },
        { type: "interpolateYlOrBr", reversed: true },
        { type: "interpolateYlOrRd", reversed: false },
        { type: "interpolateYlOrRd", reversed: true },
        { type: "interpolateBrBG", reversed: false },
        { type: "interpolateBrBG", reversed: true },
        { type: "interpolatePRGn", reversed: false },
        { type: "interpolatePRGn", reversed: true },
        { type: "interpolatePiYG", reversed: false },
        { type: "interpolatePiYG", reversed: true },
        { type: "interpolatePuOr", reversed: false },
        { type: "interpolatePuOr", reversed: true },
        { type: "interpolateRdBu", reversed: false },
        { type: "interpolateRdBu", reversed: true },
        { type: "interpolateRdGy", reversed: false },
        { type: "interpolateRdGy", reversed: true },
        { type: "interpolateRdYlBu", reversed: false },
        { type: "interpolateRdYlBu", reversed: true },
        { type: "interpolateRdYlGn", reversed: false },
        { type: "interpolateRdYlGn", reversed: true }
    ];
    // Get custom colors
    const customColorsContext = (0, react_1.useContext)(CustomColorsContext_1.CustomColorsContext);
    // Number of colors needed. Null doesn't count to length
    const numColors = props.categories.filter((c) => c.value != null).length;
    if (customColorsContext && customColorsContext.customColors.filter((c) => c != null).length > 0) {
        const customPalettes = [];
        for (let i = 0; i < customColorsContext.customColors.length; i += 6) {
            const customPalette = customColorsContext.customColors.slice(i, i + 6);
            customPalettes.push({ type: "custom", reversed: false, colors: customPalette.filter((c) => c != null) });
        }
        palettes.unshift(...customPalettes);
    }
    function generatePaletteColors(palette, numColors) {
        if (palette.type === "custom") {
            return palette.colors;
        }
        return ColorSchemeFactory_1.default.createColorScheme({
            type: palette.type,
            number: numColors,
            reversed: palette.reversed
        });
    }
    const onPaletteSelected = (index) => {
        // Generate color map
        const scheme = generatePaletteColors(palettes[index], numColors);
        const colorMap = lodash_1.default.map(props.categories, (category, i) => ({
            value: category.value,
            color: category.value === null ? "#aaaaaa" : scheme[i % scheme.length]
        }));
        return props.onPaletteSelected(colorMap);
    };
    const renderCancel = () => {
        if (props.axis.colorMap) {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("a", { className: "link-plain", onClick: props.onCancel, key: "cancel-customize" }, T `Cancel`)));
        }
        return null;
    };
    function renderPalette(palette, index) {
        return (react_1.default.createElement(ColorPaletteComponent, { key: index, index: index, colorSet: generatePaletteColors(palette, 6), onPaletteSelected: onPaletteSelected }));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("p", null, T `Please select a color scheme`),
        palettes.map((palette, index) => renderPalette(palette, index)),
        renderCancel()));
}
exports.default = ColorPaletteCollectionComponent;
class ColorPaletteComponent extends react_1.default.Component {
    handleSelect = () => {
        return this.props.onPaletteSelected(this.props.index);
    };
    render() {
        return (react_1.default.createElement("div", { onClick: this.handleSelect, className: "axis-palette" }, lodash_1.default.range(Math.max(6, this.props.colorSet.length)).map((i) => {
            const color = this.props.colorSet[i];
            const cellStyle = {
                display: "inline-block",
                height: 20,
                width: 20,
                backgroundColor: color ?? "transparent"
            };
            return react_1.default.createElement("div", { style: cellStyle, key: i }, " ");
        })));
    }
}
